export interface ServiceDetailsMaster {
  id: number;
  serviceName: string;
  portalEnabled: boolean;
}
